<template>
  <van-badge :offset="[-13, 13]" color="#67C23A">
    <div class="time-label">
      <span>{{ title }}</span>
      <div v-if="type == 1" class="type-content">
        <span>未打卡</span>
      </div>
      <div v-else class="type-content">
        <van-icon name="checked" color="#1989FA" />
        <span style="margin-left: 3pxs">{{ timeLabel }}</span>
        <span
          v-if="isShowUpdate"
          style="color: #1989fa; margin-left: auto; margin-right: 10px"
          @click="clickUpdate"
          >更新打卡</span
        >
      </div>
    </div>
    <template #content v-if="isShowBadge">
      <van-icon name="success" class="badge-icon" />
    </template>
  </van-badge>
</template>

<script setup lang="ts">
const emits = defineEmits(["clickUpdate"]);
defineProps({
  title: { type: String, default: "" },
  timeLabel: { type: String, default: "" },
  // 自定义的类型，1 未打卡 2 已打卡
  type: { type: Number, default: 1 },
  isShowBadge: { type: Boolean, default: false },
  isShowUpdate: { type: Boolean, default: false },
});
// 点击了更新打卡
const clickUpdate = () => {
  emits("clickUpdate");
};
</script>

<style scoped>
.time-label {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  color: #333333fe;
  font-size: 13px;
  background-color: #f2f3f5;
  border-radius: 4px;
}
.type-content {
  width: 100%;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  gap: 3px;
  margin-top: 3px;
  color: #969799;
  font-size: 12px;
  align-items: baseline;
}

.badge-icon {
  display: block;
  font-size: 10px;
  line-height: 16px;
}
</style>
